<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page

========================================================================================== -->


<template>
  <div id="knowledge-base-page">
    <!-- JUMBOTRON -->
    <div class="rounded-lg w-full mb-4"
         style="background-image: url(https://cdn.discordapp.com/attachments/733851758211629347/954057924391600218/BG.png);
         box-shadow: 0px 4px 25px 0px rgba(0,0,0,.1);">
      <div class="knowledge-base-jumbotron-content lg:p-20 md:p-16 sm:p-12 p-8 rounded-lg mb-4"
           style="backdrop-filter: blur(10px); height: 100%;">
        <h5 class="font-light">Course Selector</h5>
        <h1 class="mb-1 text-white font-bold" style="font-size: 2.9rem">Select a Course to Practice</h1>
      </div>
    </div>

    <!-- COURSE SELECT CARDS  -->
    <div>
      <slide-x-left-transition group class="vx-row match-height" tag="div">
        <div v-for="item in courses_total" :key="item.id" class="vx-col card-width-course mb-base">
          <course-selector-card :item="item"/>
        </div>
      </slide-x-left-transition>
    </div>
    <div v-if="!courses_loaded && !courses_none && courses_total.length === 0" class="simple-spinner">
      <span></span>
    </div>
    <h1 v-if="courses_none">You Have No Courses On Your Account</h1>
  </div>
</template>

<!--suppress ES6ShorthandObjectProperty -->
<script>
import CourseSelectorCard from "./components/CourseSelectorCard";

export default {
  data () {
    return {
      course_selector_query: '',
      courses_total: [],
      courses_loaded: false,
      courses_none: false,
    }
  },
  computed: {
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    }
  },
  methods: {
    get_course_list () {
      this.$http.get('users/@me/subscriptions')
        .then(subscriptions => {


          if (subscriptions.data.data.length === 0) {
            this.courses_none = true
            // location.replace('https://www.youtube.com/watch?v=jE2VvGZktJo')
          }

          subscriptions.data.data.forEach(x => {
            this.$http.get(`courses/${x.course_id}`)
              .then(async response => {
                if (response.status === 200 && response.data.data.status === 'active') {
                  if (!this.activeCourseInfo.selected) {
                    this.courses_total.push(response.data.data)
                  }
                  if (this.activeCourseInfo.selected && this.activeCourseInfo.id !== response.data.data.id) {
                    this.courses_total.push(response.data.data)
                  }
                }
              })
          })

          if (this.activeCourseInfo && this.activeCourseInfo.selected !== false) {
            this.courses_total.push(this.activeCourseInfo)
          }

          this.courses_loaded = true

        })
    }
  },
  beforeDestroy () {
    this.courses_total = null
  },
  beforeMount () {
    this.get_course_list()
  },
  components: {
    CourseSelectorCard
  }
}
</script>
<style lang="scss">

.card-width-course {
  width: 20%;
}

@media (max-width: 2200px) {
  .card-width-course {
    width: 25%;
  }
}

@media (max-width: 1800px) {
  .card-width-course {
    width: 33.333333%;
  }
}

@media (max-width: 1300px) {
  .card-width-course {
    width: 50%;
  }
}
@media (max-width: 750px) {
  .card-width-course {
    width: 100%;
  }
}
</style>

